import { ShieldCheck } from "lucide-react";
import { useLanguage } from "../../i18n/language-provider";

/**
 * components/legal/PaymentMarks.tsx
 *
 * The accepted card schemes and the 3-D Secure mark, shown where the gateway
 * looks for them: "Loga umístěte buď do patičky webu, nebo na stránku týkající
 * se prodeje." It is item 10 of GoPay's merchant checklist and the one item
 * that is not satisfied by a sentence inside a legal document — the reviewer
 * reads the public footer, logged out.
 *
 * These are **wordmarks set in the product's own type**, not the schemes' own
 * artwork. That is deliberate: an approximated Visa or Mastercard logo is a
 * worse answer than a clean, legible name, and the real files belong to the
 * schemes. To ship the official marks, take the SVGs from GoPay's brand kit
 * (or Visa's / Mastercard's own brand centre), drop them in as inline SVG, and
 * replace the `<span>` for that entry — the surrounding layout, the label and
 * the 3-D Secure entry stay as they are.
 *
 * The list is what `optivo-service/src/routes/billing.ts` can actually charge
 * through GoPay. Adding a method here without adding it there would put a
 * promise on the public site that checkout does not keep.
 */

const CARD_SCHEMES = ["Visa", "Mastercard"] as const;

export function PaymentMarks() {
    const { t } = useLanguage();

    return (
        <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-muted-foreground">
                {t.welcome.footerPaymentsLabel}
            </span>
            {CARD_SCHEMES.map((scheme) => (
                <span
                    key={scheme}
                    className="rounded-sm border border-border px-2 py-0.5 text-xs font-medium tracking-[0.06em] text-foreground"
                >
                    {scheme}
                </span>
            ))}
            <span className="inline-flex items-center gap-1 rounded-sm border border-border px-2 py-0.5 text-xs font-medium tracking-[0.06em] text-foreground">
                <ShieldCheck className="size-3" aria-hidden="true" />
                3-D Secure
            </span>
        </div>
    );
}
